import { useEffect, useRef, useState } from "react";
import { Search, Upload } from "react-feather";
import { FaSearch } from "react-icons/fa";
import { useSelector } from "react-redux";
import {
  getBulkDropdownData,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import { filterNcrList, getNcrRequestList } from "../../api/ncrApi";
import { statusByContext } from "../../api/statusApi";
import Grid from "../../components/Grid";
import LoadingSpinner from "../../components/LoadingSpinner";
import Tab from "../../components/Tab";
import Button from "../../components/input/Button";
import Dropdown from "../../components/input/Dropdown";
import Input from "../../components/input/Input";
import SearchDropdown from "../../components/input/SearchDropdown";
import SideDrawer from "../../components/input/SideDrawer";
import {
  ActiveCellStyle,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
  StatusLabelStyle,
} from "../../components/renderer/StyleRenderer";
import {
  activeById,
  FORMS,
  MODULES,
  PINNED_COLUMN_COLOR,
  STATUS_GROUPS,
  statusById,
} from "../../const";
import useUserCompany from "../../hooks/useUserCompany";
import NCRCreate from "./NCRCreate";

const NCR = () => {
  const [tab, setTab] = useState(1);
  const gridRef = useRef();
  const auth = useSelector(
    (state) => state.user.permissions[MODULES.Transaction]
  );
  const ncrPermission = auth[FORMS.NCR.UPLOAD];
  const ncrViewPermission = ncrPermission?.FORM?.VIEW;
  const ncrCreatePermission = ncrPermission?.FORM?.CREATE;
  const [ncrId, setNcrId] = useState("");
  const [ncrCode, setNcrCode] = useState("");
  const [reqCode, setReqCode] = useState("");
  const [reqId, setReqId] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [activeAccordion1, setActiveAccordion1] = useState(true);
  const [activeAccordion2, setActiveAccordion2] = useState(true);
  const [dateTypeOptions, setDateTypeOptions] = useState([]);
  const [jobStatusOptions, setJobStatusOptions] = useState([]);
  const [ncrTypeOptions, setNcrTypeOptions] = useState([]);
  const [statusOpt, setStatusOpt] = useState([]);
  const [activeOpt, setActiveOpt] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [resetSearchFields, setResetSearchFields] = useState(false);
  const [searchFieldReset, setSearchFieldReset] = useState(false);

  const [dateType, setDateType] = useState(1);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState(new Date().toISOString().split("T")[0]);
  const [customer, setCustomer] = useState("");
  const [shipper, setShipper] = useState("");
  const [jobStatus, setJobStatus] = useState("");
  const [jobNos, setJobNos] = useState("");
  const [reqNos, setReqNos] = useState("");
  const [vehNos, setVehNos] = useState("");
  const [status, setStatus] = useState(2);
  const [active, setActive] = useState(1);

  const [fromDate2, setFromDate2] = useState("");
  const [toDate2, setToDate2] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [projectName, setProjectName] = useState("");
  const [reportedBy, setReportedBy] = useState("");
  const [ncrType, setNcrType] = useState("");
  const [customer2, setCustomer2] = useState("");
  const [reqCodes, setReqCodes] = useState("");
  const [ncrCodes, setNcrCodes] = useState("");

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isSearchResultsPending, setIsSearchResultsPending] = useState(false);
  const [isSearchResultsPending2, setIsSearchResultsPending2] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [searchResults2, setSearchResults2] = useState([]);
  const [searchClicked, setSearchClicked] = useState(false);
  const [searchClicked2, setSearchClicked2] = useState(false);
  const userCompany = useUserCompany();
  const [company, setCompany] = useState(
    userCompany ? userCompany.comId : null
  );
  useEffect(() => {
    setCompany(userCompany ? userCompany.comId : null);
  }, [userCompany]);

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
    setEditMode(false);
  };

  const handleAccordionClick1 = (index) => {
    setActiveAccordion1(index);
  };

  const handleAccordionClick2 = (index) => {
    setActiveAccordion2(index);
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      //new
      const {
        date_types: dateTypeData,
        ncr_type: ncrType,
        status: statusSet,
        active: activeSet,
      } = await getBulkDropdownData([
        { key: "date_types" },
        { key: "ncr_type" },
        { key: "status" },
        { key: "active" },
      ]);

      setDateTypeOptions(dateTypeData);
      setNcrTypeOptions(ncrType);
      setStatusOpt(statusSet);
      setActiveOpt(activeSet);

      const jobStatusData = await statusByContext(STATUS_GROUPS.ALL);
      setJobStatusOptions(jobStatusData);

      // const companies = await getCompanies();
      // setCompanyOptions(companies);

      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    const aWeekAgo = new Date();
    aWeekAgo.setDate(aWeekAgo.getDate() - 30);
    const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
    const formattedToday = new Date().toISOString().split("T")[0];
    setFromDate(formattedWeekAgo);
    setToDate(formattedToday);
    setFromDate2(formattedWeekAgo);
    setToDate2(formattedToday);
  }, []);

  const handleSearch = async () => {
    setSearchClicked(true);
    setIsSearchResultsPending(true);

    try {
      const data = {
        pageSize: null,
        page: null,
        dateType,
        fromDate,
        toDate,
        customer: customer ? customer.toString() : "-2",
        shipper: shipper ? shipper.toString() : "-2",
        jobStatus: jobStatus ? jobStatus.toString() : "-2",
        jobNos: jobNos ? jobNos.toString() : "-2",
        requestNos: reqNos ? reqNos.toString() : "-2",
        vehicleNos: vehNos ? vehNos.toString() : "-2",
        flagedType: "",
        resolved: "",
        status: status ? status.toString() : "-2",
        active: active ? active.toString() : "-2",
      };

      const searchResults = await getNcrRequestList(data);
      let mappedResults = searchResults?.map((result) => {
        return {
          ...result,
          createdDate: result.createdDate
            ? result.createdDate.split("T")[0]
            : "",
        };
      });
      console.log(searchResults);
      setSearchResults(mappedResults);
      handleAccordionClick1(false);
    } catch (e) {
      console.error(e);
    }
    setIsSearchResultsPending(false);
  };

  const handleSearch2 = async () => {
    setSearchClicked2(true);
    setIsSearchResultsPending2(true);
    try {
      const data = {
        ncrCodes: ncrCodes.toString(),
        fromDate: fromDate2, //from reported date
        toDate: toDate2, //from reported date
        company: company.toString(),
        projectName: projectName.toString(),
        reportedBy: reportedBy.toString(),
        ncrType: ncrType.toString(),
        customer: customer2.toString(),
        reqIds: "",
        reqCodes: reqCodes.toString(),
      };

      const searchResults = await filterNcrList(data);
      console.log("search results", searchResults);
      let mappedResults = searchResults?.map((result) => {
        return {
          ...result,
          ncrReportedDate: result.ncrReportedDate
            ? result.ncrReportedDate.split("T")[0]
            : "",
          ncrImmDate: result.ncrImmDate ? result.ncrImmDate.split("T")[0] : "",
          ncrCorrDate: result.ncrCorrDate
            ? result.ncrCorrDate.split("T")[0]
            : "",
          ncrPreDate: result.ncrPreDate ? result.ncrPreDate.split("T")[0] : "",
          ncrReevaluationDate: result.ncrReevaluationDate
            ? result.ncrReevaluationDate.split("T")[0]
            : "",
          ncrStatus: statusById[result.ncrStatus],
          ncrActive: activeById[result.ncrActive],
        };
      });

      setSearchResults2(mappedResults);
    } catch (e) {
      console.error(e);
    }
    handleAccordionClick2(false);
    setIsSearchResultsPending2(false);
  };

  const handleReset = () => {
    setResetSearchFields(!resetSearchFields);
    setSearchClicked(false);
    setSearchResults([]);

    const aWeekAgo = new Date();
    aWeekAgo.setDate(aWeekAgo.getDate() - 30);
    const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
    const formattedToday = new Date().toISOString().split("T")[0];
    setFromDate(formattedWeekAgo);
    setToDate(formattedToday);
    setCustomer("");
    setShipper("");
    setJobStatus("");
    setJobNos("");
    setReqNos("");
    setVehNos("");
    setResetSearchFields(true);
    setActive(1);
    setStatus(2);
  };

  const handleReset2 = () => {
    setSearchClicked2(false);
    setSearchResults2([]);
    const aWeekAgo = new Date();
    aWeekAgo.setDate(aWeekAgo.getDate() - 30);
    const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
    const formattedToday = new Date().toISOString().split("T")[0];
    setFromDate2(formattedWeekAgo);
    setToDate2(formattedToday);
    setCompany("");
    setProjectName("");
    setReportedBy("");
    setNcrType("");
    setCustomer2("");
    setReqCodes("");
    setNcrCodes("");
    setSearchFieldReset(true);
  };

  return (
    <div>
      <div className="ui tabular menu top attached">
        {ncrViewPermission && (
          <Tab
            Icon={FaSearch}
            onClick={() => {
              setTab(1);
            }}
            active={tab === 1}
            label="NCR List Search"
            authenticated={false}
            // form={FORMS}
            // module={MODULES.Transaction}
          />
        )}
        {ncrCreatePermission && (
          <Tab
            Icon={Upload}
            onClick={() => {
              setTab(2);
            }}
            active={tab === 2}
            label="NCR Upload"
            field="NCR Upload"
            authenticated={false}
            // form={FORMS.NCR.DOCUMENT.form}
            // module={MODULES.Transaction}
          />
        )}
      </div>

      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 2 ? "block" : "none", width: "100%" }}
      >
        {ncrCreatePermission && (
          <>
            <div
              className="ui styled accordion"
              style={{ width: "100%", marginBottom: "10px" }}
            >
              <div
                className={`title ${activeAccordion1 ? "active" : ""}`}
                onClick={() => handleAccordionClick1(!activeAccordion1)}
              >
                <div>
                  Click here to search
                  <Search size={14} style={{ marginLeft: "10px" }} />
                  <i className="dropdown icon"></i>
                </div>
              </div>
              <div className={`content ${activeAccordion1 ? "active" : ""}`}>
                {isLoading ? (
                  <LoadingSpinner />
                ) : (
                  <form className="ui form">
                    <h4 className="ui dividing header">Information</h4>

                    <div className="four fields">
                      <Dropdown
                        label="Date Type"
                        clearable
                        options={dateTypeOptions}
                        placeholder="Date Type"
                        style={{ height: "20px" }}
                        value={dateType}
                        onChange={(e, data) => {
                          setDateType(data.value);
                        }}
                      />

                      <Input
                        label="From Date"
                        type="date"
                        name="fromDate"
                        value={fromDate}
                        onChange={(e) => {
                          setFromDate(e.target.value);
                        }}
                      />

                      <Input
                        label="To Date"
                        type="date"
                        name="toDate"
                        value={toDate}
                        onChange={(e) => {
                          setToDate(e.target.value);
                        }}
                      />

                      <Dropdown
                        clearable
                        search={true}
                        options={jobStatusOptions}
                        placeholder="Job Status"
                        label="Job Status"
                        value={jobStatus}
                        onChange={(e, data) => {
                          setJobStatus(data.value);
                        }}
                        multiple={false}
                      />
                    </div>
                    <div className="four fields">
                      <SearchDropdown
                        key={1}
                        editMode={false}
                        reset={resetSearchFields}
                        setReset={setResetSearchFields}
                        clearable={true}
                        onClear={() => {
                          setCustomer("");
                        }}
                        onResultSelect={(data) => setCustomer(data)}
                        api={getOtherRefSearchDropdown}
                        apiDependency={{
                          type: "stakeholder_type",
                          value: "Customer",
                        }}
                        label="Request Customer"
                      />

                      <SearchDropdown
                        key={2}
                        editMode={false}
                        reset={resetSearchFields}
                        setReset={setResetSearchFields}
                        clearable={true}
                        onClear={() => {
                          setShipper("");
                        }}
                        onResultSelect={(data) => setShipper(data)}
                        api={getOtherRefSearchDropdown}
                        apiDependency={{
                          type: "stakeholder_type",
                          value: "Shipper",
                        }}
                        label="Shipper/Plant"
                      />

                      {/* <SearchDropdown
                        key={1}
                        editMode={false}
                        reset={searchFieldReset}
                        setReset={setSearchFieldReset}
                        clearable={true}
                        onClear={() => {
                          setTransporter("");
                        }}
                        onResultSelect={(data) => setTransporter(data)}
                        api={getOtherRefSearchDropdown}
                        apiDependency={{
                          type: "stakeholder_type",
                          value: "Transporter",
                        }}
                        label="Transporter"
                      /> */}
                      {/* <Input
                        label="Request Id"
                        type="text"
                        placeholder="Request Id"
                        name="reqids"
                        value={reqIds}
                        onChange={(e) => {
                          setReqIds(e.target.value);
                        }}
                      /> */}
                      <Input
                        label="Job Code"
                        type="text"
                        placeholder="Example - 234,235"
                        name="jobnos"
                        value={jobNos}
                        onChange={(e) => {
                          setJobNos(e.target.value);
                        }}
                      />

                      <Input
                        label="Request Code"
                        type="text"
                        placeholder="Example - 234,235"
                        name="reqnos"
                        value={reqNos}
                        onChange={(e) => {
                          setReqNos(e.target.value);
                        }}
                      />
                    </div>

                    <div className="three fields">
                      <Input
                        label="Vehicle Number"
                        type="text"
                        placeholder="Vehicle Number"
                        name="vehnos"
                        value={vehNos}
                        onChange={(e) => {
                          setVehNos(e.target.value);
                        }}
                      />
                      <Dropdown
                        clearable
                        options={statusOpt}
                        placeholder="Status"
                        label="Status"
                        value={status}
                        onChange={(e, data) => {
                          setStatus(data.value);
                        }}
                      />

                      <Dropdown
                        clearable
                        options={activeOpt}
                        placeholder="Status"
                        label="Active"
                        value={active}
                        onChange={(e, data) => {
                          setActive(data.value);
                        }}
                      />
                    </div>

                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div className="field" style={{ width: "100%" }}>
                        <Button template="search" onClick={handleSearch} />
                        <Button template="searchReset" onClick={handleReset} />
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>

            {searchClicked && (
              <>
                {isSearchResultsPending ? (
                  <LoadingSpinner />
                ) : (
                  <Grid
                    isLoading={isSearchResultsPending}
                    autoHeight={true}
                    // rowHeight={50}
                    searchable={true}
                    config={[
                      {
                        headerName: "Request Code",
                        field: "reqCode",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        pinned: "left",
                        cellStyle: { backgroundColor: "#fff9c4" },
                      },
                      {
                        headerName: "Job Code",
                        field: "jobCode",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#DDFFE7" },
                      },
                      {
                        headerName: "Customer",
                        field: "customerName",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                      },
                      {
                        headerName: "Plant",
                        field: "plantName",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                      },
                      {
                        headerName: "Vehicle Number",
                        field: "vehVehicleNo",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                      },
                      // {
                      //   headerName: "Transporter",
                      //   field: "stkName",
                      //   width: 180,
                      //   cellRenderer: ResizableScrollingTextRenderer,
                      // },
                      {
                        headerName: "Driver",
                        field: "driverName",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                      },
                      {
                        headerName: "Billing Customer",
                        field: "billingCustomer",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                      },
                      {
                        headerName: "Invoice Customer",
                        field: "invoicingCustomer",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                      },
                      {
                        headerName: "Job Charge Type",
                        field: "chargeType",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                      },
                      {
                        headerName: "Created By",
                        field: "createdBy",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                      },
                      {
                        headerName: "Created Date",
                        field: "createdDate",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                      },
                      {
                        headerName: "Request Status",
                        field: "statusName",
                        width: 180,
                        minWidth: 180,
                        cellRenderer: StatusCellStyle,
                        pinned: "right",
                      },
                      {
                        headerName: "Job Status",
                        field: "staName",
                        width: 180,
                        minWidth: 180,
                        cellRenderer: StatusLabelStyle,
                        cellStyle: (params) => ({
                          backgroundColor:
                            params.data.staColor || PINNED_COLUMN_COLOR,
                        }),
                        pinned: "right",
                      },
                    ]}
                    content={searchResults}
                    ref={gridRef}
                    onCellDoubleClicked={(props) => {
                      setIsDrawerOpen(true);
                      setReqCode(props.data.reqCode);
                      setReqId(props.data.reqId);
                      setEditMode(false);
                    }}
                  />
                )}
              </>
            )}
          </>
        )}
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none", width: "100%" }}
      >
        {ncrViewPermission && (
          <>
            <div
              className="ui styled accordion"
              style={{ width: "100%", marginBottom: "10px" }}
            >
              <div
                className={`title ${activeAccordion2 ? "active" : ""}`}
                onClick={() => handleAccordionClick2(!activeAccordion2)}
              >
                <div>
                  Click here to search
                  <Search size={14} style={{ marginLeft: "10px" }} />
                  <i className="dropdown icon"></i>
                </div>
              </div>
              <div className={`content ${activeAccordion2 ? "active" : ""}`}>
                {isLoading ? (
                  <LoadingSpinner />
                ) : (
                  <form className="ui form">
                    <h4 className="ui dividing header">Information</h4>

                    <div className="three fields">
                      <Input
                        label="NCR Code"
                        type="text"
                        placeholder="Example - NCR-00001,NCR-00002"
                        name="ncrCode"
                        value={ncrCodes}
                        onChange={(e) => setNcrCodes(e.target.value)}
                      />
                      <Input
                        label="From Date (Reported Date)"
                        type="date"
                        name="fromDate"
                        value={fromDate2}
                        onChange={(e) => {
                          setFromDate2(e.target.value);
                        }}
                      />

                      <Input
                        label="To Date (Reported Date)"
                        type="date"
                        name="toDate"
                        value={toDate2}
                        onChange={(e) => {
                          setToDate2(e.target.value);
                        }}
                      />
                    </div>
                    <div className="four fields">
                      <Input
                        type="text"
                        label="Project Name"
                        name="projectName"
                        placeholder="Project Name"
                        value={projectName}
                        onChange={(e) => setProjectName(e.target.value)}
                      />
                      <SearchDropdown
                        key={1}
                        editMode={false}
                        reset={searchFieldReset}
                        setReset={setSearchFieldReset}
                        clearable={true}
                        onClear={() => {
                          setCustomer2("");
                        }}
                        onResultSelect={(data) => setCustomer2(data)}
                        api={getOtherRefSearchDropdown}
                        apiDependency={{
                          type: "stakeholder_type",
                          value: "Customer",
                        }}
                        label="Customer"
                      />

                      <Input
                        type="text"
                        label="Reported By"
                        name="reportedBy"
                        placeholder="Reported By"
                        value={reportedBy}
                        onChange={(e) => setReportedBy(e.target.value)}
                      />
                      <Dropdown
                        label="NCR Type"
                        name="ncrType"
                        placeholder="NCR Type"
                        options={ncrTypeOptions}
                        value={ncrType}
                        onChange={(e, data) => setNcrType(data.value)}
                      />
                    </div>

                    <div className="four fields">
                      {/* <Input
                        label="Request Ids"
                        type="text"
                        placeholder="Example - 1,2,3"
                        name="reqids"
                        value={reqIds2}
                        onChange={(e) => {
                          setReqIds2(e.target.value);
                        }}
                      /> */}
                      <Input
                        label="Request Code"
                        type="text"
                        placeholder="Example - REQ-00001,REQ-00002"
                        name="reqcodes"
                        value={reqCodes}
                        onChange={(e) => {
                          setReqCodes(e.target.value);
                        }}
                      />
                    </div>

                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div className="field" style={{ width: "100%" }}>
                        <Button template="search" onClick={handleSearch2} />
                        <Button template="searchReset" onClick={handleReset2} />
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
            {searchClicked2 && (
              <>
                {isSearchResultsPending2 ? (
                  <LoadingSpinner />
                ) : (
                  <Grid
                    isLoading={isSearchResultsPending2}
                    autoHeight={true}
                    // rowHeight={50}
                    searchable={true}
                    config={[
                      {
                        headerName: "Request Code",
                        field: "ncrReqCode",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        pinned: "left",
                        cellStyle: { backgroundColor: "#EFE7D3" },
                      },
                      {
                        headerName: "NCR Code",
                        field: "ncrCode",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#EFE7D3" },
                      },
                      {
                        headerName: "Company",
                        field: "ncrCompanyLabel",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#D3BBDD" },
                      },
                      {
                        headerName: "Project Name",
                        field: "ncrProjectName",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#D3BBDD" },
                      },
                      {
                        headerName: "Reported By",
                        field: "ncrReportedBy",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#D3BBDD" },
                      },
                      {
                        headerName: "NCR Cost",
                        field: "ncrCost",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#D3BBDD" },
                      },
                      {
                        headerName: "Reported Date",
                        field: "ncrReportedDate",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#D3BBDD" },
                      },
                      {
                        headerName: "NCR Type",
                        field: "ncrTypeValue",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#D3BBDD" },
                      },
                      {
                        headerName: "Customer Name",
                        field: "ncrCustomerName",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#D3BBDD" },
                      },
                      {
                        headerName: "Customer Complaint",
                        field: "ncrCustomerComplaintLabel",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#D3BBDD" },
                      },
                      {
                        headerName: "Made Via",
                        field: "ncrMadeViaLabel",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#D3BBDD" },
                      },
                      {
                        headerName: "Severity",
                        field: "ncrSeverityLabel",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#D3BBDD" },
                      },
                      {
                        headerName: "Concern Reported",
                        field: "ncrConcernReported",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#D3BBDD" },
                      },
                      {
                        headerName: "Cause",
                        field: "ncrCause",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#D3BBDD" },
                      },
                      {
                        headerName: "Immediate Action",
                        field: "ncrImmAction",
                        width: 200,
                        minWidth: 200,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#fff9c4" },
                      },
                      {
                        headerName: "Immediate By",
                        field: "ncrImmBy",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#fff9c4" },
                      },
                      {
                        headerName: "Immediate Date",
                        field: "ncrImmDate",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#fff9c4" },
                      },
                      {
                        headerName: "Corrective Action",
                        field: "ncrCorrAction",
                        width: 200,
                        minWidth: 200,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#FF8A8A" }, //red background color
                      },
                      {
                        headerName: "Corrective By",
                        field: "ncrCorrBy",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#FF8A8A" }, //red background color
                      },
                      {
                        headerName: "Corrective Date",
                        field: "ncrCorrDate",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#FF8A8A" }, //red background color
                      },
                      {
                        headerName: "Preventive Action",
                        field: "ncrPreAction",
                        width: 200,
                        minWidth: 200,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#DDFFE7" }, //green background color
                      },
                      {
                        headerName: "Preventive By",
                        field: "ncrPreBy",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#DDFFE7" }, //green background color
                      },
                      {
                        headerName: "Preventive Date",
                        field: "ncrPreDate",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#DDFFE7" }, //green background color
                      },
                      {
                        headerName: "Final Outcome",
                        field: "ncrFinalOutcome",
                        width: 180,
                        minWidth: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#8FDDE7" }, //blue background color
                      },
                      {
                        headerName: "Feedback Given",
                        field: "ncrFeedbackGiven",
                        width: 180,
                        minWidth: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#8FDDE7" }, //blue background color
                      },
                      {
                        headerName: "Feedback Reevaluation",
                        field: "ncrFeedbackReevaluation",
                        width: 180,
                        minWidth: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#8FDDE7" }, //blue background color
                      },

                      {
                        headerName: "Reevaluation Date",
                        field: "ncrReevaluationDate",
                        width: 180,
                        cellRenderer: ResizableScrollingTextRenderer,
                        cellStyle: { backgroundColor: "#8FDDE7" }, //blue background color
                      },

                      {
                        headerName: "NCR Status",
                        field: "ncrStatus",
                        width: 100,
                        MaxWidth: 100,
                        cellRenderer: StatusCellStyle,
                      },
                      {
                        headerName: "Active",
                        field: "ncrActive",
                        width: 100,
                        MaxWidth: 100,
                        cellRenderer: ActiveCellStyle,
                      },
                    ]}
                    content={searchResults2}
                    ref={gridRef}
                    onCellDoubleClicked={(props) => {
                      setIsDrawerOpen(true);
                      setReqCode(props.data.ncrReqCode);
                      setReqId(props.data.ncrReqId);
                      setNcrId(props.data.ncrId);
                      setNcrCode(props.data.ncrCode);
                      setEditMode(true);
                    }}
                  />
                )}
              </>
            )}
          </>
        )}
      </div>

      <SideDrawer
        open={isDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        head={
          !editMode ? (
            <h3 className="ui header">Request Code: {reqCode}</h3>
          ) : (
            <h3 className="ui header">
              NCR Code: {ncrCode} / Request Code: {reqCode}
            </h3>
          )
        }
        body={
          <NCRCreate
            reqCode={reqCode}
            reqId={reqId}
            ncrid={ncrId}
            ncrCode={ncrCode}
            editMode={editMode}
            handleDrawerClose={handleDrawerClose}
          />
        }
        style={{ width: "90vw" }}
      />
    </div>
  );
};

export default NCR;
